{
    "CRMConfiguration_Table_Headers_Description": "Beschrijving",
    "CRMConfiguration_Table_Headers_Type": "Type",
    "CRMConfiguration_Table_Headers_TelSys": "Telefonieserver",
    "CRMConfiguration_Table_Headers_Partition": "Partitie",
    "CRMConfiguration_Table_Headers_Device": "Apparaat",
    "NAME": "CRMConfigurationLanguage"
}